import { Component, inject, OnInit } from "@angular/core";

import {
    ImageComponent,
    provideScene7ImageSettings,
} from "@hermes/aphrodite-image";
import {
    registerSvgs,
    svgHermesLogo,
    svgHermesLogoSmall,
    SvgIconComponent,
} from "@hermes/aphrodite-svg";

import { LOCALE, Settings } from "@hermes/core-app-core";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

export const HERMES_LOGO_PATH = "hermes-logo";
@Component({
    selector: "h-logo",
    imports: [SrOnlyNoSnippetDirective, SvgIconComponent, ImageComponent],
    templateUrl: "./logo.component.html",
    styleUrls: ["./logo.component.scss"],
    providers: [provideScene7ImageSettings({ maxWidth: 250 })],
})
export class LogoComponent implements OnInit {
    private locale = inject(LOCALE);
    private settings = inject(Settings);

    public homeUrl: string | undefined;

    public hermesLogoPath = `${this.settings.assetsUrlEditoImage}${HERMES_LOGO_PATH}`;

    constructor() {
        registerSvgs([svgHermesLogo, svgHermesLogoSmall]);
    }

    public ngOnInit(): void {
        this.homeUrl = `${this.locale.urlPrefix}/`;
    }
}
